import { createAction, props } from '@ngrx/store';
import { Scopes } from '../../models/scope.model';

export const SCOPES_FEATURE_NAME = 'scopes';
const ACTIONS_SUFFIX = SCOPES_FEATURE_NAME.toUpperCase();

export const getScopes = createAction(
  `[${ACTIONS_SUFFIX} Get scopes list]`,
);

export const setScopes = createAction(
  `[${ACTIONS_SUFFIX} Set scopes list]`,
  props<{ scopes: Scopes }>(),
);

export const getScopesFailure = createAction(
  `[${ACTIONS_SUFFIX} Get scopes list failure]`,
);
